import {BaseService} from './baseservice';

class OrganizationsServiceClass extends BaseService {
    constructor() {
        super();
        this.organizations = [];
    }

    async init() {
        this.organizations = [];

        const response = await this.fetch('GET', '/organizations');

        if (response && response.data && response.data.organizations) {
            this.organizations = this.organizations.concat(
                response.data.organizations
            );
        }
    }

    list() {
        return this.organizations;
    }

    async updateWeekStartDay(body, org) {
        const response = await this.fetch('PUT', '/organizations/' + org, body);
        if (response && response.data) {
            return response.data;
        }
    }

    async getOrganizationsCodes() {
        const response = await this.fetch('GET', '/organizations/codes');
        if (response && response.data) {
            return response.data;
        }
    }

    async updateRollingMonth(rollingMonth, orgId) {
        try {
            const response = await this.fetch(
                'PUT',
                `/organizations/${orgId}`,
                {ptqr_rolling_months: rollingMonth}
            );
            if (response && response.data) {
                return response.data;
            }
        } catch (e) {
            return null;
        }
    }
}

let OrganizationsService = new OrganizationsServiceClass(ENVIRONMENT.API_HOST);
export default OrganizationsService;
